import React from "react";
import { useLocation, useNavigate } from "react-router";
import { AdminFormPage } from "@components/CatalogIndex";
import CreditForm from "../CreditForm/CreditForm";
import { ProjectCredit, PaymentCreditOption } from "../types/ProjectCredit";

const FORM_ID = "credit-form";

interface Props {
  projectId: string;
  permission: string;
  projectStatus: string;
  paymentCredits: PaymentCreditOption[];
}

const Edit: React.FC<Props> = ({
  projectId,
  permission,
  projectStatus,
  paymentCredits,
}) => {
  const navigate = useNavigate();
  const routeLocation = useLocation();
  const credit: ProjectCredit = routeLocation.state?.credit;
  const canSave = permission === "manage" && projectStatus === "building";

  return (
    <AdminFormPage
      title="Edit Payment Credit"
      formId={canSave ? FORM_ID : undefined}
      onCancel={() =>
        navigate(`/projects/${projectId}/project_credits`, {
          state: null,
        })
      }
    >
      <CreditForm
        formId={FORM_ID}
        projectId={projectId}
        credit={credit}
        paymentCredits={paymentCredits}
      />
    </AdminFormPage>
  );
};

export default Edit;
